<template>
  <v-list
    v-model:opened="open"
    class="change-business pa-0"
  >
    <!-- mini mode -->
    <v-list-item
      v-if="mini"
      class="change-business__icon"
    >
      <v-icon>
        domain
      </v-icon>
    </v-list-item>

    <!-- multiple businesses -->
    <v-list-group
      v-else-if="businessRoles?.length > 1 && !mini"
      color="secondary"
      value="Users"
    >
      <template v-slot:activator="{ props }">
        <v-list-item 
          v-bind="props"
          class="change-business__title"
          :value="loggedUser.business?.name"
          :title="loggedUser.business?.name"
        />
      </template>

      <div class="mb-2 change-business__items">
        <v-list-item
          density="compact"
          v-for="(businessRole, key) in businessRoles"
          :key="businessRole.business_id"
          @click="switchBusiness(businessRole, key)"
          color="primary"
          :active="isCurrentBusiness(businessRole)"
        >
        
          {{ businessRole.businessName }}
          <v-icon
            v-if="isCurrentBusiness(businessRole)"
            color="primary"
            size="small"
          >
            done
          </v-icon>
        </v-list-item>
      </div>
    </v-list-group>

    <!-- single -->
    <v-list-item
      v-else
      class="change-business__title"
    >
      <v-list-item-title v-text="loggedUser.business?.name"/>
    </v-list-item>
  </v-list>
</template>

<script>
  export default {
    props: {
      user: {
        type: Object,
        default: undefined,
      },
      mini: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      switchButtonsLoading: [],
      open: [],
    }),
    computed: {
      loggedUser() {
        return this.$store.getters['auth/user'];
      },
      businessRoles() {
        if (!this.loggedUser?.available_roles?.length) {
          return [];
        }
        const arr = this.loggedUser.available_roles
          .sort((a, b)=> {
            if (a.business.id === this.loggedUser.last_business_id) return -1;
            if (b.business.id === this.loggedUser.last_business_id) return 1;
            if (a.business.name.toUpperCase() < b.business.name.toUpperCase()) return -1;
            if (a.business.name.toUpperCase() > b.business.name.toUpperCase()) return 1;
          })

        const index = arr.indexOf(item => item.business.id === this.loggedUser.last_buiness_id);

        if (index > -1) {
          arr.splice(0, 0, arr.splice(index, 1)[0]);
        }

        return arr.map((brole) => ({
          role: brole.slug,
          roleName: brole.name,
          business_id: brole.business?.id,
          businessName: brole.business?.name,
          status: brole.status.id,
          statusName: brole.status.name,
        }));
      },
    },
    methods: {
      isCurrentBusiness(businessRole){
        return this.loggedUser.business?.id === businessRole.business_id;
      },
      switchBusiness(businessRole, key) {
        if (this.isCurrentBusiness(businessRole)) {
          return;
        }

        const newBusinessId = businessRole.business_id;
        this.switchButtonsLoading[key] = 1;

        return this.$store
          .dispatch('businessUsers/switchBusiness', newBusinessId)
          .catch((err) => err);
      },
    },
  }
</script>

<style lang="scss">
.navigation {
  .change-business {
    flex-grow: 0;
    flex-basis: auto;

    // icon size when in mini mode
    .v-icon {
      height: 31px;
      width: 35px;
    }

    &__icon {
      display: flex;
      justify-content: center;
      min-height: 51px;
      padding-inline: 0 !important;
    }

    .v-list-item-title {
      font-size: 14px;
      font-weight: 600;
    }

    &__title {
      min-height: 51px;
    }

    &__title.v-list-item {
      margin-bottom: 0;
    }

    &__items {
      .v-list-item {
        min-height: 33px;
        padding: 0 44px 0 36px;
      }

      .v-list-item--active {
        font-weight: 700;

        &:before {
          background-color: rgb(var(--v-theme-surface));
        }
      }

      .v-list-item__content {
        font-size: 14px;
      }
    }
  }
}
</style>
